import { getBackOfficeEntityDataSource } from './index';
import type { IInwinkEntityDataSourceOptions } from '@@api/base/datasource';

export function communityEntityViewDataSource(communityid: string, options?: IInwinkEntityDataSourceOptions) {
    return getBackOfficeEntityDataSource<any>(communityid + "/", "communityentityview", "CommunityEntityView", options);
}
